// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2-Kwx","footer":"ModalInfo_footer__nJfrF"};